import { m } from "#messages";
import type { Ladder } from "#lib/upsell.ts";
import type { LockedScene } from "./LockedPreview.svelte";

export interface UpgradePitch {
  readonly title: string | null;
  readonly message: string;
  readonly tier: string | null;
  readonly href: string | null;
  readonly ladder: Ladder;
  readonly testId: string;
  readonly scene: LockedScene;
}

const shown = $state<{ pitch: UpgradePitch | null; open: boolean }>({ pitch: null, open: false });

export const upgradePitch = (): { pitch: UpgradePitch | null; open: boolean } => shown;

export const pitchUpgrade = (pitch: UpgradePitch): void => {
  shown.pitch = pitch;
  shown.open = true;
};

export interface ControlLock {
  readonly reason: string;
  readonly pitch: (() => void) | null;
}

export const controlLock = (pitch: UpgradePitch): ControlLock => ({
  reason: pitch.title ?? m.upsell_not_on_plan(),
  pitch: pitch.href === null || pitch.tier === null ? null : () => pitchUpgrade(pitch),
});
